import { createContext, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import { translations } from "./translations";
import SEOMeta from "./components/SEOMeta";
import CookieBanner from "./components/CookieBanner";
import ScrollToTop from "./components/ScrollToTop";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import HomePage       from "./pages/HomePage";
import RoomsPage      from "./pages/RoomsPage";
import ExperiencePage from "./pages/ExperiencePage";
import LocationPage   from "./pages/LocationPage";
import GalleryPage    from "./pages/GalleryPage";
import ContactPage    from "./pages/ContactPage";
import BookingPage    from "./pages/BookingPage";

import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";

export const LanguageContext = createContext(null);

function App() {
  const [lang, setLangState] = useState(
    () => localStorage.getItem("aurora_lang") || "it"
  );

  const setLang = (l) => {
    localStorage.setItem("aurora_lang", l);
    setLangState(l);
  };

  const t = translations[lang];

  return (
    <HelmetProvider>
      <LanguageContext.Provider value={{ lang, setLang, t }}>
        <BrowserRouter>
          <SEOMeta />
          <ScrollToTop />
          <div className="App" data-testid="app-root">
            <Navbar />
            <main>
              <Routes>
                <Route path="/"           element={<HomePage />} />
                <Route path="/camere"     element={<RoomsPage />} />
                <Route path="/esperienza" element={<ExperiencePage />} />
                <Route path="/posizione"  element={<LocationPage />} />
                <Route path="/galleria"   element={<GalleryPage />} />
                <Route path="/contatti"   element={<ContactPage />} />
                <Route path="/prenota"    element={<BookingPage />} />
                <Route path="/privacy"    element={<PrivacyPolicyPage />} />
                {/* Redirect unknown paths to home */}
                <Route path="*"           element={<HomePage />} />
              </Routes>
            </main>
            <Footer />
            <CookieBanner />
          </div>
        </BrowserRouter>
      </LanguageContext.Provider>
    </HelmetProvider>
  );
}

export default App;
